<template>
  <PanelV2
    type="w4"
    mode="simple"
  >
    <template v-slot:content-solt>
      <p>Are you already a BDO Merchant?</p>
      <div style="text-align: center;margin: 0 0 100px 0;">
        <el-button  @click="onNo" >No</el-button>
        <el-button  @click="onYes" type="primary">Yes</el-button>
      </div>
    </template>
  </PanelV2>
</template>

<script>
  import API from "@/api";
  import MD5 from '@/plugins/crypto-md5.js'
  export default {
    name: 'WhetherBDOMerchant',
    pRouter: 'CheckYourEmail',
    data() {
      return {
      }
    },
    methods: {
      onYes() {
        API.chooseBdoProcess({
          token: this.getCookieItem('token'),
          processNo: '5',
        }).then(res => {
          if (res.success) {
            this.toRoute({name: 'BdoMerchantA'})
          }
        })
      },
      onNo() {
        window._DEBUG_MODE = false

        if (window._DEBUG_MODE) {
          API.login({
              userName: '981685450@qq.com',
              password: MD5('Xiaoas213')
            }).then(res => {
              if (res.success) {
                // this.setCookieItem('', '');
                this.setCookieItem('token', res.obj.token);
                this.setCookieItem('merchantId', res.obj.merchantId);
                this.toRoute({ name: 'ChooseMerchantType' });
              }
            })
        } else {
          this.toRoute({ name: 'ChooseMerchantType' });
        }
      }
    }
  }
</script>


<style lang="scss" scoped>

  .panel-v2 {
    p {
      font: normal normal normal 24px/32px Nunito-bold;
      letter-spacing: 0px;
      color: #2E2E2E;
      margin: 80px 0 48px;
    }
  }
</style>
